import { Component, OnInit } from '@angular/core';
import { FnModalService, FnToasterService, FnUtilService } from 'foundation';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { AdminSetupService } from './admin-setup.service';
import { PosUtilService } from '../../../services/pos-util.service';

@Component({
  selector: 'app-admin-setup',
  templateUrl: './admin-setup.component.html',
  styleUrl: './admin-setup.component.scss'
})
export class AdminSetupComponent implements OnInit {
  isLoggedIn = false;
  loadUser = false;
  loadAlgo = false;
  userRoleArray: userRole[] = [];
  userArray: user[] = [];
  algoArray: { aiAgoType: string }[] = [];

  objectHash: adminSetup = {
    appName: '',
    glbApiKey: '',
    glbAssetsUrl: '',
    glbAssetsApiKey: '',
    callbackUrl: '',
    idpUrl: '',
    isIDPEnabled: true,
    apiKey: '',
    adminRoleEmailIDs: '',
    offsetInMonthsToDelFailedPkts: 0,
    appUrl: '',
    offSetDaysToDelete: 90,
    offSetToDeleteTimerTask: 90,
    enableDeleteOldHistory: true,
    enableStatistics: false,
    isDBServiceDown: false,
    cachedDisableSetupArray: '',
    hwCetUrl: '',
    hwCetApiKey: '',
    globalAssetsUrl: '',
    globalAssetsApiKey: '',
    glbAssetsPublicUrl: '',
    atsServiceApiKey: '',
    atsServiceUrl: '',
    atsServicePublicUrl: '',
    edmApiKey: '',
    edmServerUrl: '',
    edmAgentApiKey: '',
    cetUrl: '',
    cetApiKey: '',
    atsConsumerUrl: '',
    isLoggingEnabled: false,
    userInfoForLoging: '',
    environmentID: '',
    enablePushNotification: false,
    mailServerUrl: '',
    enableSignalService: false,
    mailServerApiKey: '',
    urlShortnerSvcsUrl: '',
    urlShortnerSvcsApiKey: '',
    enableUrlShortnerSvcs: false,
    redisHost: '',
    redisPHash: '',
    redisPort: 0,
    redisDatabase: 0,
    isRedisEnabled: false,
    isAlertForceToSave: false,
    teligramUrl: '',
    teligramApiKey: '',
    enabletelegramService: false,
    atsConsumerUrlArr: '',
    defaultViewerUserName: '',
    adminUsers: '',
    helpUrlDir: '',
    localHelpUrlDir: '',
    toBeUpdateKeySet: '',
    sqlTrackerUrl: '',
enableMailService: false,
  }

  constructor(
    private adminSetup: AdminSetupService,
    private toaster: FnToasterService,
    public posUtil: PosUtilService
  ) { }

  ngOnInit(): void {
    if (localStorage.getItem('isLoggedIn') == "yes") {
      this.isLoggedIn = true
    }
    else {
      this.isLoggedIn = false;
    }
    this.getAdminSetup();
    this.getUserRole();
  }


  addRow() {
    this.userArray.push({
      username: '',
      primaryKey: 0,
      role: {
        roleName: '',
        primaryKey: 0
      }
    });
  }

  deleteUser(index: number) {
    const user = this.userArray[index];
    this.userArray.splice(index, 1);
    this.deleteAdminUser(user.primaryKey);
  }

  deleteAdminUser(objectHash: number) {
    this.adminSetup.deleteUser(objectHash).subscribe(resp => {
      if (resp.isError) {
        this.toaster.error(resp.message);
        return;
      }
      this.toaster.success("User is deleted Succesfully")
    });
    this.toaster.success("User is deleted Succesfully")
  }

  getAdminSetup() {
    this.adminSetup.getAdminSetup().subscribe(resp => {
      if (resp.isError) {
        this.toaster.error(resp.message);
        return;
      }
      this.objectHash = resp.data;

    });

  }

  getUserRole() {
    this.adminSetup.getUserRole().subscribe(resp => {
      if (resp.isError) {
        this.toaster.error(resp.message);
        return;
      }
      this.userRoleArray = resp.data;

    });
    this.adminSetup.getUser().subscribe(resp => {
      if (resp.isError) {
        this.toaster.error(resp.message);
        return;
      }

      this.userArray = resp.data;
      this.loadUser = true;
    });
  }

  saveData() {
    this.updateAdminSetup(this.objectHash);
  }

  saveUser(user: user) {
    this.updateUser(user);
  }

  updateUser(objectHash: user) {
    this.adminSetup.updateUser(objectHash).subscribe(resp => {
      if (resp.isError) {
        this.toaster.error(resp.data);
        return;
      }
      this.toaster.success("User is Updated Succesfully");
    });

  }

  updateAdminSetup(objectHash: adminSetup) {
    this.adminSetup.updateAdminSetup(objectHash).subscribe(resp => {
      if (resp.isError) {
        this.toaster.error(resp.message);
        return;
      }
      this.toaster.success("Admin Setup is Updated Succesfully")
    }
    );
  }

}

export interface adminSetup {

  appName: string,
  glbApiKey: string,
  glbAssetsUrl: string,
  glbAssetsApiKey: string,
  callbackUrl: string,
  idpUrl: string,
  isIDPEnabled: boolean,
  apiKey: string,
  adminRoleEmailIDs: string,
  offsetInMonthsToDelFailedPkts: number,
  appUrl: string,
  offSetDaysToDelete: number,
  offSetToDeleteTimerTask: number,
  enableDeleteOldHistory: boolean,
  enableStatistics: boolean,
  isDBServiceDown: boolean,
  cachedDisableSetupArray: string,
  hwCetUrl: string,
  hwCetApiKey: string,
  globalAssetsUrl: string,
  globalAssetsApiKey: string,
  glbAssetsPublicUrl: string,
  atsServiceApiKey: string,
  atsServiceUrl: string,
  atsServicePublicUrl: string,
  edmApiKey: string,
  edmServerUrl: string,
  edmAgentApiKey: string,
  cetUrl: string,
  cetApiKey: string,
  atsConsumerUrl: string,
  isLoggingEnabled: boolean,
  userInfoForLoging: string,
  environmentID: string,
  enablePushNotification: boolean,
  mailServerUrl: string,
  enableSignalService: boolean,
  mailServerApiKey: string,
  urlShortnerSvcsUrl: string,
  urlShortnerSvcsApiKey: string,
  enableUrlShortnerSvcs: boolean,
  redisHost: string,
  redisPHash: string,
  redisPort: number,
  redisDatabase: number,
  isRedisEnabled: boolean,
  isAlertForceToSave: boolean,
  teligramUrl: string,
  teligramApiKey: string,
  enabletelegramService: boolean,
  atsConsumerUrlArr: string,
  defaultViewerUserName: string,
  adminUsers: string,
  helpUrlDir: string,
  localHelpUrlDir: string,
  toBeUpdateKeySet: string,
  sqlTrackerUrl: string,
  enableMailService: boolean,


}

export interface user {
  username: string
  primaryKey: number
  role: userRole
}

export interface userRole {
  roleName: string
  primaryKey: number
}

